<template>
  <div class="voucher-notice">
    <div v-if="isAndroidOSGoogle" class="common-benefit">
      <h4>* Google Play 첫 결제 시, 첫 달 ￦100 프로모션</h4>
      <ul class="exclamation-list">
        <li
          v-for="(text, index) in androidOsNotice"
          :key="`android_os_notice__${index}`"
        >
          <span v-html="text"></span>
        </li>
      </ul>
    </div>

    <div class="common-benefit partner-benefit-box">
      <strong class="title">{{ benefitTitle }}</strong>
      <ul class="common-benefit-list">
        <li
          v-for="(item, index) in benefitList"
          :key="`common_benefits__${index}`"
        >
          <span v-html="item"></span>
        </li>
      </ul>
    </div>

    <VoucherBottomGuide :device="device" />
  </div>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import VoucherBottomGuide from '@/components/lnb/voucher/VoucherBottomGuide.vue'
  import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
  import { PAYMENT_GATE_TYPE_ONE_STORE } from '@/common/constant'
  import {
    VOUCHER_COMMON_BENEFITS,
    VOUCHER_ANDROID_OS_NOTICE,
  } from '@/components/lnb/voucher/voucher-text/const.js'

  // note: 현재는 사용하지 않음, 그러나 w-t-의경우 사용하기 때문에 프로퍼티 유지
  const props = defineProps({
    device: {
      type: String,
      default: '',
    },
    voucherType: {
      type: String,
      default: '',
    },
    pgName: {
      type: String,
      default: '',
    },
  })

  const benefitTitle = computed(() => '이용권 공통 혜택')
  const benefitList = computed(() => VOUCHER_COMMON_BENEFITS)
  const androidOsNotice = computed(() => VOUCHER_ANDROID_OS_NOTICE)
  const isOneStore = computed(
    () => props.pgName === PAYMENT_GATE_TYPE_ONE_STORE,
  )
  const isAndroidOS = computed(() => props.device === DEVICE_TYPE_ANDROID)
  const isAndroidOSGoogle = computed(
    () => isAndroidOS.value && !isOneStore.value,
  )
</script>
<style lang="scss" scoped>
  .partner-benefit-box {
    .title {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      font-weight: 400;
    }
    .box {
      > dl {
        width: 100%;
        dt {
          font-size: 12px;
          line-height: 18px;
          font-weight: bold;
          color: #a5a5a5;
        }
        dd {
          position: relative;
          margin-top: 8px;
          padding-left: 24px;
          font-size: 12px;
          line-height: 16px;
          color: #a5a5a5;
          word-break: break-all;
          vertical-align: middle;
          &:first-of-type {
            margin-top: 12px;
          }
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 16px;
            height: 16px;
            background: url(~@/assets/images/ticket/element-icons-16-x-16-default-ic-check-list-small-copy@3x.png)
              no-repeat center / cover;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>
